export * from './NewGameStep1'
export * from './NewGameStep2'
export * from './NewGameStep3'



// WEBPACK FOOTER //
// src/pages/MC/NewGame/index.js